<template>
  <el-dialog
    title="修改账户信息"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="editForm"
      :model="form"
      :rules="rules"
      label-width="120px"
      v-loading="loading"
    >
      <el-form-item label="公司名称：" prop="companyName">
        <el-input
          v-model="form.companyName"
          placeholder="请输入公司名称"
          maxlength="50"
        ></el-input>
        <div v-if="companyNameError" style="color: red; font-size: 12px; margin-top: 5px;">{{ companyNameError }}</div>
      </el-form-item>
      
      <el-form-item label="营业执照照片：" v-if="licenseFileUrl">
        <a :href="licenseFileUrl" target="_blank" style="color: red;">{{ licenseFileName }}</a>
      </el-form-item>
      
      <el-form-item label="上传营业执照：" v-if="showUpload">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
          :show-file-list="false"
          accept="image/*"
          name="fileVal"
        >
          <el-button size="small" type="primary">上传</el-button>
        </el-upload>
        <div v-if="uploadSuccess" style="margin-top: 10px; font-size: 14px;">
          文件上传成功！<a :href="newLicenseFileUrl" target="_blank" style="color: red;">点击查看</a>
        </div>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateCompany, getCompanyInfo } from '@/api/member'

export default {
  name: 'EditHyxUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 公司名称验证规则
    const validateCompanyName = (rule, value, callback) => {
      if (!value) {
        this.companyNameError = '请输入[公司名]'
        callback(new Error('请输入[公司名]'))
        return
      }
      
      // 公司名格式验证
      if (!/^[\(\)（）\u4e00-\u9fa5]{1,64}$/.test(value)) {
        this.companyNameError = '公司名格式不正确'
        callback(new Error('公司名格式不正确'))
        return
      }
      
      this.companyNameError = ''
      callback()
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      form: {
        companyName: '',
        companyId: 0
      },
      rules: {
        companyName: [
          { required: true, validator: validateCompanyName, trigger: 'blur' }
        ]
      },
      companyNameError: '',
      licenseFileUrl: '',
      licenseFileName: '',
      newLicenseFileUrl: '',
      uploadSuccess: false,
      showUpload: true,
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      },
      companyInfo: null
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initForm()
        this.fetchCompanyInfo()
      }
    }
  },
  methods: {
    initForm() {
      this.form = {
        companyName: this.userData.company_name || '',
        companyId: this.userData.company_id || 0
      }
      this.companyNameError = ''
      this.uploadSuccess = false
      this.newLicenseFileUrl = ''
    },
    
    async fetchCompanyInfo() {
      if (!this.userData.company_id) return
      
      this.loading = true
      try {
        const res = await getCompanyInfo({ id: this.userData.company_id })
        if (res.err_code === 0) {
          this.companyInfo = res.data
          if (res.data.license_file_url) {
            this.licenseFileUrl = res.data.license_file_url
            // 提取文件名
            this.licenseFileName = res.data.license_file_url.substring(res.data.license_file_url.lastIndexOf("/") + 1)
          }
        }
      } catch (error) {
        console.error('获取公司信息失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    handleUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        this.newLicenseFileUrl = response.data
        this.uploadSuccess = true
      } else {
        this.$message.error('上传失败: ' + response.err_msg)
      }
    },
    
    handleUploadError(err, file, fileList) {
      console.error('上传失败:', err)
      this.$message.error('上传失败，请检查网络连接或联系管理员')
    },
    
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        
        // 检查是否做了修改
        const originalCompanyName = this.userData.company_name || ''
        const isCompanyNameChanged = this.form.companyName !== originalCompanyName
        const isLicenseFileChanged = this.newLicenseFileUrl !== ''
        
        if (!isCompanyNameChanged && !isLicenseFileChanged) {
          this.$message.warning('未做修改')
          this.handleClose()
          return
        }
        
        this.submitting = true
        try {
          const params = {
            id: this.userData.company_id,
            user_id: this.userData.id
          }
          
          // 只有在修改了公司名称时才添加
          if (isCompanyNameChanged) {
            params.name = this.form.companyName
          }
          
          // 只有在上传了新文件时才添加
          if (isLicenseFileChanged) {
            params.license_file_url = this.newLicenseFileUrl
          }
          
          // 调用更新公司信息接口
          const res = await updateCompany(params)
          if (res.err_code === 0) {
            this.$message.success('保存成功')
            this.$emit('success')
            this.handleClose()
          } else if (res.err_code === 1201) {
            this.$message.error('公司已存在')
          } else if (res.err_code === 1002) {
            this.$message.error('没有权限')
          } else if (res.err_code === 1062) {
            this.$message.error('公司名称已存在')
          } else {
            this.$message.error(res.err_msg || '保存失败')
          }
        } catch (error) {
          console.error('保存失败:', error)
          this.$message.error('保存失败: ' + error.message)
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}

.upload-demo {
  display: inline-block;
}
</style>